export default [
  {
    position: "absolute",
    top: 19.5,
    left: 37,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "hiringP2.mTitleOne",
    mBody: "hiringP2.mBodyOne",
    id: "SP_Hiring_Info_InternalVacancies",
    infoIcon: true,
    isAction: false,
    index: 0
  },
  {
    position: "absolute",
    top: 1.1,
    left: 0.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 9,
    tooltipText: "hiringP2.ttTextOne",
    hover: false,
    tooltipClass: "right",
    id: "SP_Hiring_Navigation_Menu",
    index: 1
  },
  {
    position: "absolute",
    top: 7.2,
    left: 12.9,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "hiringP2.ttTextTwo",
    hover: false,
    id: "SP_Hiring_Navigation_Communications",
    index: 2
  },
  {
    position: "absolute",
    top: 7.2,
    left: 35.3,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "hiringP2.ttTextThree",
    hover: false,
    id: "SP_Hiring_Navigation_PayBenefits",
    index: 3
  },
  {
    position: "absolute",
    top: 7.2,
    left: 43.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 6,
    tooltipText: "hiringP2.ttTextFour",
    hover: false,
    id: "SP_Hiring_Navigation_Absence",
    index: 4
  },
  {
    position: "absolute",
    top: 7.2,
    left: 50.1,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "hiringP2.ttTextFive",
    hover: false,
    id: "SP_Hiring_Navigation_Performance",
    index: 5
  },
  {
    position: "absolute",
    top: 5.4,
    left: 98.3,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "hiringP2.ttTextSix",
    hover: false,
    tooltipClass: "left",
    id: "SP_Hiring_Navigation_TeamMember",
    index: 6
  },
  {
    position: "absolute",
    top: 50.5,
    left: 16.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 11,
    tooltipText: "hiringP2.ttTextSeven",
    hover: false,
    id: "SP_Hiring_Navigation_MyVacancies",
    index: 7
  },
];
